import {
    Container,
    Graphics,
    Text,
} from 'pixi.js';
import { SCREEN_HEIGHT, SCREEN_WIDTH, FONT_UI } from '../GameConst';
import { userDataManager } from '../utils/UserDataManager';

export class StatusWindow extends Container {
    constructor(){
        super();

        const background = new Graphics().lineStyle(5, 0xFFFFFF, 1).beginFill(0x000000, 0.75).drawRoundedRect(0, 0, SCREEN_WIDTH * 0.8, 200, 16);
        background.pivot.set(background.width * 0.5, background.height * 0.5);
        this.addChild(background);

        const namePlate = new Graphics().beginFill(0xFFFFFF, 1).drawRoundedRect(0, 0, SCREEN_WIDTH * 0.6, 60, 16);
        namePlate.pivot.set(namePlate.width * 0.5, namePlate.height * 0.5);
        this.addChild(namePlate);
        namePlate.y = background.height * -0.5;

        const nameText = new Text(userDataManager.Name, {
            fontFamily: FONT_UI,
            fontSize: namePlate.height * 0.5,
            fill: 'black',
        });
        nameText.anchor.set(0.5);
        nameText.y = namePlate.y;
        this.addChild(nameText);

        const levelText = new Text(`レベル : ${userDataManager.Level}`, {
            fontFamily: FONT_UI,
            fontSize: namePlate.height * 0.5,
            fill: 'white',
        });
        levelText.x = -background.width * 0.3;
        levelText.y = -levelText.height;
        this.addChild(levelText);

        const nextLevelText = userDataManager.NextLevelExp ? `（次のレベルまで ${userDataManager.NextLevelExp - userDataManager.Exp}）` : '';
        const expText = new Text(`経験値 : ${userDataManager.Exp}${nextLevelText}`, {
            fontFamily: FONT_UI,
            fontSize: namePlate.height * 0.5,
            fill: 'white',
        });
        expText.x = -background.width * 0.3;
        expText.y = expText.height * 0.5;
        this.addChild(expText);

        this.x = SCREEN_WIDTH * 0.5;
        this.y = SCREEN_HEIGHT * 0.18;
    }
}
